export interface SelectOption {
    label: string
    value: string
}

// TODO(WSP-1143) The WP_DOMAIN should be type defined
// Should not export the value only the type
export const WP_DOMAIN = 'wisepelican.com'

// TODO(WSP-1143) The list of accepted extensions should be type defined
// Should not export the value only the type
export const acceptedExtensionsArray = [
    '.jpg',
    '.jpeg',
    '.png',
    '.pdf',
    '.jfif',
    '.gif',
    '.tif',
    '.tiff',
    '.webp',
    '.svg',
    '.jpe',
    '.aspx',
    '.ashx',
    '.meg',
    '.nef',
]

// TODO(WSP-1143) The list of states should be type defined.
// Should not export the value only the type
export const states: SelectOption[] = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District Of Columbia', value: 'DC' },
    { label: 'Federated States Of Micronesia', value: 'FM' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Guam', value: 'GU' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Northern Mariana Islands', value: 'MP' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Palau', value: 'PW' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virgin Islands', value: 'VI' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
] as const

// TODO(WSP-1143) The list of colors should be type defined if shareable, at the moment it is only used in 1 component.
// Should not export the value only the type
export const customColorPickerQuickPickColors = [
    '#FFD700',
    '#FF6F61',
    '#4CAF50',
    '#2196F3',
    '#9C27B0',
    '#FFEB3B',
    '#FF9800',
    '#03A9F4',
    '#E91E63',
    '#3F51B5',
    '#8BC34A',
    '#00BCD4',
    '#9E9E9E',
    '#607D8B',
    '#673AB7',
    '#FF5722',
    '#795548',
    '#000000',
    '#ff0040',
    '#bf0030',
    '#800020',
    '#400010',
    '#ff4080',
    '#bf3060',
    '#bf0040',
    '#8f0030',
    '#802040',
    '#600020',
    '#401020',
    '#300010',
    '#ff80bf',
    '#ff0080',
    '#bf608f',
    '#bf4080',
    '#bf0060',
    '#8f3060',
    '#804060',
    '#800040',
    '#602040',
    '#600030',
    '#402030',
    '#400020',
    '#301020',
    '#200010',
    '#ff40bf',
    '#bf308f',
    '#bf0080',
    '#8f0060',
    '#802060',
    '#600040',
    '#401030',
    '#300020',
    '#ff00bf',
    '#bf008f',
    '#800060',
    '#400030',
    '#ffbfff',
    '#ff80ff',
    '#ff40ff',
    '#ff00ff',
    '#bf8fbf',
    '#bf80bf',
    '#bf60bf',
    '#bf40bf',
    '#bf30bf',
    '#bf00bf',
    '#8f608f',
    '#8f308f',
    '#8f008f',
    '#806080',
    '#804080',
    '#802080',
    '#800080',
    '#604060',
    '#603060',
    '#602060',
    '#600060',
    '#403040',
    '#402040',
    '#401040',
    '#400040',
    '#302030',
    '#301030',
    '#300030',
    '#201020',
    '#200020',
    '#100010',
    '#bf00ff',
    '#8f00bf',
    '#600080',
    '#300040',
    '#bf40ff',
    '#8f30bf',
    '#8000bf',
    '#602080',
    '#60008f',
    '#400060',
    '#301040',
    '#200030',
    '#bf80ff',
    '#8f60bf',
    '#8040bf',
    '#8000ff',
    '#604080',
    '#60308f',
    '#6000bf',
    '#402060',
    '#400080',
    '#302040',
    '#300060',
    '#201030',
    '#200040',
    '#100020',
    '#8040ff',
    '#6030bf',
    '#402080',
    '#4000bf',
    '#30008f',
    '#201040',
    '#200060',
    '#100030',
    '#4000ff',
    '#3000bf',
    '#200080',
    '#100040',
    '#bfbfff',
    '#8f8fbf',
    '#8080ff',
    '#8080bf',
    '#606080',
    '#6060bf',
    '#60608f',
    '#404080',
    '#404060',
    '#4040ff',
    '#4040bf',
    '#303040',
    '#3030bf',
    '#30308f',
    '#303060',
    '#202040',
    '#202030',
    '#202080',
    '#202060',
    '#101040',
    '#101030',
    '#101020',
    '#0000ff',
    '#0000bf',
    '#000080',
    '#000040',
    '#00008f',
    '#000060',
    '#000030',
    '#000020',
    '#000010',
    '#0040ff',
    '#0030bf',
    '#002080',
    '#001040',
    '#4080ff',
    '#3060bf',
    '#204080',
    '#102040',
    '#0040bf',
    '#00308f',
    '#002060',
    '#001030',
    '#80bfff',
    '#608fbf',
    '#4080bf',
    '#406080',
    '#30608f',
    '#204060',
    '#203040',
    '#102030',
    '#0080ff',
    '#0060bf',
    '#004080',
    '#003060',
    '#002040',
    '#001020',
    '#40bfff',
    '#308fbf',
    '#206080',
    '#103040',
    '#0080bf',
    '#00608f',
    '#004060',
    '#002030',
    '#00bfff',
    '#008fbf',
    '#006080',
    '#003040',
    '#bfffff',
    '#8fbfbf',
    '#80ffff',
    '#80bfbf',
    '#60bfbf',
    '#608f8f',
    '#608080',
    '#40ffff',
    '#40bfbf',
    '#408080',
    '#406060',
    '#30bfbf',
    '#308f8f',
    '#306060',
    '#304040',
    '#208080',
    '#206060',
    '#204040',
    '#203030',
    '#104040',
    '#103030',
    '#102020',
    '#00ffff',
    '#00bfbf',
    '#008f8f',
    '#008080',
    '#006060',
    '#004040',
    '#003030',
    '#002020',
    '#001010',
    '#00ffbf',
    '#00bf8f',
    '#008060',
    '#004030',
    '#40ffbf',
    '#30bf8f',
    '#208060',
    '#104030',
    '#00bf80',
    '#008f60',
    '#006040',
    '#003020',
    '#80ffbf',
    '#60bf8f',
    '#40bf80',
    '#408060',
    '#308f60',
    '#206040',
    '#204030',
    '#103020',
    '#00ff80',
    '#00bf60',
    '#008040',
    '#006030',
    '#004020',
    '#002010',
    '#40ff80',
    '#30bf60',
    '#208040',
    '#104020',
    '#00bf40',
    '#008f30',
    '#006020',
    '#003010',
    '#00ff40',
    '#00bf30',
    '#008020',
    '#004010',
    '#bfffbf',
    '#8fbf8f',
    '#80ff80',
    '#80bf80',
    '#60bf60',
    '#608f60',
    '#608060',
    '#40ff40',
    '#40bf40',
    '#408040',
    '#406040',
    '#30bf30',
    '#308f30',
    '#306030',
    '#304030',
    '#208020',
    '#206020',
    '#204020',
    '#203020',
    '#104010',
    '#103010',
    '#102010',
    '#00ff00',
    '#00bf00',
    '#008f00',
    '#008000',
    '#006000',
    '#004000',
    '#003000',
    '#002000',
    '#001000',
    '#40ff00',
    '#30bf00',
    '#208000',
    '#104000',
    '#80ff40',
    '#60bf30',
    '#40bf00',
    '#408020',
    '#308f00',
    '#206000',
    '#204010',
    '#103000',
    '#bfff80',
    '#8fbf60',
    '#80ff00',
    '#80bf40',
    '#60bf00',
    '#608f30',
    '#608040',
    '#408000',
    '#406020',
    '#306000',
    '#304020',
    '#204000',
    '#203010',
    '#102000',
    '#bfff40',
    '#8fbf30',
    '#80bf00',
    '#608f00',
    '#608020',
    '#406000',
    '#304010',
    '#203000',
    '#bfff00',
    '#8fbf00',
    '#608000',
    '#304000',
    '#ffffbf',
    '#ffff80',
    '#ffff40',
    '#ffff00',
    '#bfbf8f',
    '#bfbf60',
    '#bfbf30',
    '#bfbf00',
    '#bfbf80',
    '#bfbf40',
    '#8f8f60',
    '#8f8f30',
    '#8f8f00',
    '#808060',
    '#808040',
    '#808020',
    '#808000',
    '#606040',
    '#606020',
    '#606000',
    '#606030',
    '#404030',
    '#404020',
    '#404010',
    '#404000',
    '#303020',
    '#303010',
    '#303000',
    '#202010',
    '#202000',
    '#101000',
    '#ffbf00',
    '#bf8f00',
    '#806000',
    '#403000',
    '#ffbf40',
    '#bf8f30',
    '#bf8000',
    '#8f6000',
    '#806020',
    '#604000',
    '#403010',
    '#302000',
    '#ffbf80',
    '#ff8000',
    '#bf8f60',
    '#bf8040',
    '#bf6000',
    '#8f6030',
    '#806040',
    '#804000',
    '#604020',
    '#603000',
    '#403020',
    '#402000',
    '#302010',
    '#201000',
    '#ff8040',
    '#bf6030',
    '#bf4000',
    '#8f3000',
    '#804020',
    '#602000',
    '#402010',
    '#301000',
    '#ff4000',
    '#bf3000',
    '#802000',
    '#401000',
    '#ffffff',
    '#ffbfbf',
    '#ff8080',
    '#ff4040',
    '#ff0000',
    '#bfbfbf',
    '#bf8f8f',
    '#bf8080',
    '#bf6060',
    '#bf4040',
    '#bf3030',
    '#bf0000',
    '#8f8f8f',
    '#8f6060',
    '#8f3030',
    '#8f0000',
    '#808080',
    '#806060',
    '#804040',
    '#802020',
    '#800000',
    '#606060',
    '#604040',
    '#603030',
    '#602020',
    '#600000',
    '#404040',
    '#403030',
    '#402020',
    '#401010',
    '#400000',
    '#303030',
    '#302020',
    '#301010',
    '#300000',
    '#202020',
    '#201010',
    '#200000',
    '#101010',
    '#100000',
    '#000000',
]
